/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Op_StartedInputs */



/**
* | output |
* | --- |
* | "Sync started" |
*
* @param {Admin_Op_StartedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const admin_op_started = /** @type {((inputs?: Admin_Op_StartedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Op_StartedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Synchronisation lancée")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sincronización iniciada")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sincronização iniciada")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sincronizzazione avviata")
	return /** @type {LocalizedString} */ ("Sync started")
});